/* istanbul ignore file */
import { MapElementColor } from '../shared/enums';
import { GeoJsonFeature } from './geo-json-feature-model';
import { GeoJsonFile } from './geo-json-file';

export class MapContextLayer {
    id: string;
    name: string;
    description: string;
    selectedProjectIdList: string[];
    strokeWidth: number;
    strokeColor: MapElementColor;
    fillColor: MapElementColor;
    fillOpacity: number;
    order: number;
    shapeFileName: string;
    shapeFileSize: number;
    shapeFileUri: string;
    geoJsonfileName: string;
    geoJsonUri: string;
    //front end only properties
    geoJsonFeatures: GeoJsonFeature[];
    geoJsonFile: GeoJsonFile;
    isVisible = true;
}
